<template>
  <div>
    <h3 class="modal-title"> ADD THIRD PARTY CONNECTION </h3>
    <div class="sub-container">
      <b-row>
        <b-col cols="12">
          <b-form-group>
            <label> Connection Name </label>
            <div class="d-flex align-items-center">
              <div
                v-for="plugin in listPlugin"
                :key="plugin.plugin_name"
                :class="{
                  'plugin-img-selected':dataForm.plugin_name === plugin.plugin_name,
                  'error-border': $v.dataForm.plugin_name.$error
                }"
                class="plugin-options"
                @click="changeConnection(plugin)">
                <img
                  :alt="plugin.plugin_name"
                  :src="plugin.logo ? plugin.logo : &quot;@/assets/logo/privy.png&quot;"
                  class="plugin-img">
              </div>
            </div>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group :class="{'error-input' : $v.dataForm.connection_name.$error}">
            <label> Third Party Connection Name </label>
            <j-input
              v-model="dataForm.connection_name"
              :disabled="isEdit"
              placeholder="Enter connection name here"/>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group :class="{'error-input' : $v.dataForm.environment.$error}">
            <label> Environment </label>
            <j-single-select
              v-model="dataForm.environment"
              :options="listEnv"
              :placeholder="'Select environment here'"
              value-format="object"
              label="label"/>
          </b-form-group>
        </b-col>
        <b-col
          v-if="listConfig.length > 0"
          cols="12">
          <b-form-group>
            <label> Config </label>
            <div
              v-for="(data, index) in listConfig"
              :key="index + 0"
              class="list-column-ui"
            >
              <b-row>
                <b-col
                  cols="12"
                  md="6">
                  <b-form>
                    <label> Name </label>
                    <j-input
                      v-model="data.name"
                      :disabled="true"/>
                  </b-form>
                </b-col>
                <b-col
                  cols="12"
                  md="6">
                  <b-form>
                    <label> Value </label>
                    <j-input
                      v-model="data.value"
                      :placeholder="data.type"
                    />
                  </b-form>
                </b-col>
              </b-row>
            </div>
          </b-form-group>
        </b-col>
      </b-row>
    </div>

    <div class="m__t--20">
      <b-button
        v-if="isEdit"
        class="btn red"
        @click="deleteConn">
        Delete
      </b-button>

      <div class="float-right">
        <b-button
          class="btn m__r--5"
          @click="closeModal">
          Close
        </b-button>
        <b-button
          class="btn blue"
          @click="submitForm">
          Save
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';

export default {
  validations: {
    dataForm: {
      plugin_name: {
        required,
      },
      connection_name: {
        required,
      },
      environment: {
        required,
      },
      config: {

      },
    },
  },
  props: {
    listPlugin: {
      type: Array,
      default: () => [],
    },
    detailConnection: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      dataForm: {
        plugin_name: null,
        connection_name: null,
        environment: null,
        config: [],
      },
      selectedPlugin: null,
      listEnv: [],
      listConfig: [],
    };
  },
  computed: {
    isEdit() {
      return !!this.detailConnection;
    },
  },
  watch: {
    // eslint-disable-next-line
    'dataForm.connection_name': function (val){
      const regexSymbol = /[^\w\s]/g;
      if (val) {
        setTimeout(() => {
          this.dataForm.connection_name =
              val.toLowerCase()
                .replace(regexSymbol, '')
                .replace(' ', '_');
        }, 1);
      }
    },
    // eslint-disable-next-line
    'selectedPlugin': function (val) {
      if (this.isEdit) {
        if (Array.isArray(val.environment)) {
          this.listEnv = [];
          this.insertListEnv(val);
        }

        this.listConfig = [];
        const configScheme = val.config_scheme ? Object.entries(val.config_scheme)
          : Object.entries(val.config);
        configScheme.forEach((el) => {
          this.listConfig.push({
            name: el[0],
            value: el[1],
          });
        });
      } else {
        this.listEnv = [];
        this.insertListEnv(val);

        this.listConfig = [];
        const configScheme = Object.entries(val.config_scheme);
        configScheme.forEach((el) => {
          this.listConfig.push({
            name: el[0],
            type: el[1],
          });
        });
      }
    },
  },
  created() {
    if (this.isEdit) {
      // mode update
      this.selectedPlugin = this.detailConnection;

      // eslint-disable-next-line camelcase
      const { id, plugin_name: pluginName, connection_name, environment } = this.detailConnection;

      this.dataForm = {
        id,
        plugin_name: pluginName,
        connection_name,
        environment: {
          id: environment,
          label: environment,
        },
      };

      const plugin = this.listPlugin.find(val => val.plugin_name === pluginName);
      this.insertListEnv(plugin);
    } else {
      // mode create
      this.dataForm = {
        plugin_name: null,
        connection_name: null,
        environment: null,
      };
      this.$v.dataForm.$reset();
    }
  },
  methods: {
    ...mapActions('jStoreThirdParty', ['createThirdPartyConnection', 'updateThirdPartyConnection', 'deleteThirdPartyConnection']),

    async submitForm() {
      this.$v.dataForm.$touch();
      if (!this.$v.dataForm.$error) {
        // eslint-disable-next-line camelcase
        const { plugin_name, connection_name, environment } = this.dataForm;
        const params = {
          plugin_name,
          connection_name,
          environment: environment.id,
          config: {},
        };

        this.listConfig.forEach((el) => {
          params.config[el.name] = el.type === 'number' ? Number(el.value) : el.value;
        });

        let res;
        if (this.isEdit) {
          params.id = this.dataForm.id;
          res = await this.updateThirdPartyConnection(params);
        } else {
          res = await this.createThirdPartyConnection(params);
        }

        if (!res.error) {
          this.closeModal();
        }
      }
    },
    closeModal() {
      this.$emit('close-modal');
    },
    async deleteConn() {
      const text = `Are you sure to delete ${this.detailConnection.connection_name}?`;

      this.$swal({
        title: 'Delete',
        text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const params = {
            id: this.detailConnection.id,
          };
          await this.deleteThirdPartyConnection(params);
          this.closeModal();
        }
      });
    },
    changeConnection(val) {
      if (!this.isEdit) {
        this.dataForm.plugin_name = val.plugin_name;
        this.selectedPlugin = val;
      }
    },
    insertListEnv(plugin) {
      plugin.environment.forEach((el) => {
        this.listEnv.push({
          id: el,
          label: el,
        });
      });
    },
  },
};
</script>

<style lang="scss">
  .sub-container{
    border:1px solid rgba(0, 0, 0, 0.125);
    border-radius: 4px;
    padding: 15px;
  }

  .plugin-options{
    background: #FFFFFF;
    border: 1px solid #C7C6C6;
    box-sizing: border-box;
    border-radius: 4px;
    padding:10px;
    width: 100px;
    height:75px;
    margin: 10px 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .plugin-img{
      height: auto;
      width: 53px;
  }
  .plugin-img-selected{
      background: #EFF8FF;
      border: 1px solid #1A85E4;
  }
  .plugin-img-disabled{
      background: #EFF8FF;
      opacity: 0.2;
      border: 1px solid #C7C6C6;
  }
</style>



// WEBPACK FOOTER //
// src/views/third-party/jThirdPartyForm.vue